module.exports = __webpack_public_path__ + "static/media/rhoc.65cfa0ce.svg";